// extracted by mini-css-extract-plugin
export default {"wrapper":"wrapper-rQnZFi","logomark":"logomark-174oRW","wordmark":"wordmark-AwvNtX"};